const defaultState = () => {
	return {
		isActive: true,
		// used for prizing/winners widget
		selectedThLevel: 0,
	}
}

export const state = () => defaultState()

export const mutations = {
	setSelectedThLevel(state, thLevel) {
		state.selectedThLevel = thLevel
	},
}
export const actions = {
	setSelectedThLevel({ commit }, thLevel) {
		commit('setSelectedThLevel', thLevel)
	},
}

export const getters = {
	isLthActive(state) {
		return !!state.isActive
	},
	selectedThLevel(state) {
		return state.selectedThLevel
	},
}
